import dynamic from 'next/dynamic';

const MdOutlineChevronRight = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdOutlineChevronRight)
);

export default function MUIList({ list, hasArrow = false }) {
  return (
    <div className='divide-y-[1px]'>
      {list?.map((item, index) => (
        <div
          key={index}
          onClick={() => {
            item.onClickHandler();
          }}
          className='flex h-[44px] w-full items-center justify-between p-4'
        >
          <p className='mb-0 text-[16px] font-semibold uppercase text-[#2C2C2C]'>
            {item.label}
          </p>
          {hasArrow ? <MdOutlineChevronRight className='text-[24px]' /> : null}
        </div>
      ))}
    </div>
  );
}
